<template>
    <div class="main-layout" :class="{ 'main-layout--more-open': moreOpen }">
        <Header @open-more="moreOpen = true" />

        <main class="site-main">
            <div class="site-main__inner">
                <slot />
            </div>
        </main>

        <footer class="site-footer">
            <div class="footer-container">
                <p class="site-footer__brand">Волейбол Беларуси</p>
                <p class="site-footer__copy">&copy; {{ currentYear }}</p>
            </div>
        </footer>

        <MobileTabBar
            :more-open="moreOpen"
            @toggle-more="moreOpen = !moreOpen"
        />
        <MoreSheet
            :open="moreOpen"
            @close="moreOpen = false"
        />
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { usePage } from '@inertiajs/vue3';
import Header from './Header.vue';
import MobileTabBar from './MobileTabBar.vue';
import MoreSheet from './MoreSheet.vue';

defineProps({
    title: {
        type: String,
        default: 'Волейбол Беларуси',
    },
});

const moreOpen = ref(false);
const currentYear = new Date().getFullYear();
const page = usePage();

watch(
    () => page.url,
    () => {
        moreOpen.value = false;
    }
);
</script>
